module.exports = __webpack_public_path__ + "img/12.6cb09f91.jpg";